import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Input,
  Button,
  message,
  Modal,
  Tag,
  Divider,
  Switch,
  Typography,
  Checkbox,
  Result,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import { withAppContext } from "contexts/AppContext/AppContext";
import { buildBaseUri } from "utils/routes";
import moment from "moment";
import Currency from "react-currency-formatter";
import { PrimaryColor, ScreenSize } from "utils/constants";
import "./buttonRGB.css";
import { useParams } from "react-router-dom";
import { createPortalSession, successfulSubscription } from "apis/billing";

const BillingSuccessPage = () => {
  const history = useHistory();
  const { session_id } = useParams();

  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState({
    name: "",
  });

  const onBackButtonClick = () => history.push("/billing");

  useEffect(() => {
    console.log("session_id", session_id);
    getSuccessfulSubscription();

    return () => {};
  }, []);

  const getSuccessfulSubscription = async () => {
    if (session_id) {
      const res = await successfulSubscription(session_id);

      if (res.status === 200) {
        console.log("res", res);
        setCustomer(res.customer);
      }
    }
  };

  const handleManageBillingInformation = async () => {
    if (session_id) {
      const payload = {
        session_id: session_id,
      };
      createPortalSession(payload)
        .then((res) => {
          if (res.status === 200) {
            message.success("Portal session successfully created!");
            console.log("res", res);
            setTimeout(() => {
              window.location.assign(res.redirectUrl);
            }, 250);
          }
        })
        .catch((ex) => {
          Modal.error({
            title: ex.message,
          });
        });
    }
  };

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "32px" }}
      >
        <ClickableTextButton
          text="Back"
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
      </Row>

      <Result
        status="success"
        title="Successfully subscribed!"
        subTitle={`Thank you ${customer?.name} for your purchase!`}
        // extra={[
        //   <Button
        //     type="primary"
        //     key=""
        //     onClick={handleManageBillingInformation}
        //   >
        //     Manage your billing information
        //   </Button>,
        // ]}
      />
    </div>
  );
};

export default withAppContext(BillingSuccessPage);
